import React, { useState, useEffect, useRef } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./Convo.css";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";
import { Dropdown } from "react-bootstrap";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import BlockModal from "./Modals/BlockModal";
import UnBlockModal from "./Modals/UnBlockModal";
import DeleteMessageModal from "./Modals/DeleteMessageModal";
import ReportMessageModal from "./Modals/ReportMessageModal";
import DeleteConversationModal from "./Modals/DeleteConversationModal";

const Convo = ({ refreshData }) => {
  // States
  const [messages, setMessages] = useState([]);
  const [content, setContent] = useState("");

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [senderImgId, setSenderImgId] = useState(null);
  const [receiverImgId, setReceiverImgId] = useState(null);

  const [senderHasImg, setSenderHasImg] = useState(false);
  const [receiverHasImg, setReceiverHasImg] = useState(false);
  const [username, setUsername] = useState("");
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(5);
  const [noMoreMessages, setNoMoreMessages] = useState(false);
  const [shouldScroll, setShouldScroll] = useState(true); // New state to control scrolling
  const [blockUser, setBlockUser] = useState(false);
  const [UnblockUser, setUnBlockUser] = useState(false);
  const [available, setAvailable] = useState(false);
  const [youBlockedThem, setYouBlockedThem] = useState(false);
  const [deleteMessageModal, setDeleteMessageModal] = useState(false);
  const [deleteConvoModal, setDeleteConvoModal] = useState(false);
  const [reportMessageModal, setreportMessageModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
 const navi = useNavigate();
  const cancelModal = () => {
    setBlockUser(false);
    setUnBlockUser(false);
    setDeleteMessageModal(false);
    setreportMessageModal(false);
    setDeleteConvoModal(false);
  };

  // Hooks
  const { user,dispatch } = useAuthContext();
  const { id } = useParams();
  const messagesEndRef = useRef(null);

  const ViewMoreMessages = async () => {
    // Update skip and take
    const newSkip = skip + 25;

    // Fetch new posts
    const messageResponse = await axios.get(
      `${ApiConnectionString}/api/messages?Skip=${newSkip}&Take=25&ConvoId=${id}`,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (messageResponse.data.length === 0) {
      setNoMoreMessages(true);
    }

    // Append new posts to the existing ones
    setMessages((prevMes) => {
      // Combine the previous messages with the new ones
      const updatedMessages = [...prevMes, ...messageResponse.data];

      // Sort the combined messages by ID in ascending order
      updatedMessages.sort((a, b) => a.id - b.id);
      //
      return updatedMessages;
    });

    // Update state variables for skip and take
    setSkip(newSkip);
    setShouldScroll(false); // Prevent scrolling when loading more messages
  };

  //   useEffect(() => {
  //     const logHi = async () => {
  //       const newMessageResponse = await axios.get(`${ApiConnectionString}/Api/CheckForNewMessage/${id}`,
  //         {
  //           headers: { Authorization: `Bearer ${user.token}` },
  //         }
  //       );
  //       if(newMessageResponse.data == false){
  //         fetchMessages();
  //       }
  //     };
  //     const intervalId = setInterval(logHi, 10000);
  //     return () => clearInterval(intervalId);
  // }, []);

  const fetchMessages = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${ApiConnectionString}/api/messages?Skip=0&Take=25&ConvoId=${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setMessages(response.data);
      setShouldScroll(true);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      setError("Failed to load messages");
    } finally {
      setLoading(false);
      refreshData();
    }
  };

  const fetchData = async () => {
    try {
      const convoLogicResponse = await axios.get(
        `${ApiConnectionString}/api/Convos/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (convoLogicResponse.status === 200) {
        const {
          senderId,
          receiverId,
          senderHasImg,
          receiverHasImg,
          receiverUserName,
          senderUserName,
          available,
          youBlockedThem,
        } = convoLogicResponse.data;
        setYouBlockedThem(youBlockedThem);
        setAvailable(available);
        setSenderImgId(receiverId);
        setReceiverImgId(senderId);
        setSenderHasImg(receiverHasImg);
        setReceiverHasImg(senderHasImg);
        if (user.id === receiverId) {
          setUsername(senderUserName);
        } else {
          setUsername(receiverUserName);
        }
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
      fetchMessages();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
 
  }, [id,user]);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  // useEffect(() => {
  //   if (messagesEndRef.current && shouldScroll) {
  //     messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // }, [messages, shouldScroll]);

  // Handle Message Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    const newMessage = { content, ConvoId: id };

    try {
      await axios.post(`${ApiConnectionString}/api/message`, newMessage, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      setContent(""); // Reset message input
    } catch (err) {
      console.error(err);
      setError("Failed to send message");
    } finally {
      setSubmitting(false);
      fetchMessages();
    }
  };

  return (
    <div className="container bg-white rounded">
      {!loading ? (
        <div>
          <div className="border rounded p-3 m-3">
            <div className="d-flex">
              {" "}
              <p className="fw-bold red-text">{username}</p>{" "}
              <Dropdown>
                <Dropdown.Toggle
                  as="span"
                  id="dropdown-custom-components"
                  className="dropdown-toggle-custom"
                >
                  <ThreeDotsVertical
                    style={{ cursor: "pointer" }}
                    onClick={() => {}}
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {youBlockedThem ? (
                    <Dropdown.Item
                      onClick={() => {
                        setUnBlockUser(true);
                      }}
                    >
                      UnBlock user
                    </Dropdown.Item>
                  ) : (
                    <Dropdown.Item
                      onClick={() => {
                        setBlockUser(true);
                      }}
                    >
                      Block user
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item
                    onClick={() => {
                      setDeleteConvoModal(true);
                    }}
                  >
                    Delete Conversation
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <hr></hr>
       
            <div className="messages-container  py-2 px-5">
            {!noMoreMessages && (
              <button className="saveChanges-button" onClick={ViewMoreMessages}>
                View more
              </button>
            )}
              {messages.map((message) => (
                <div
                  key={message.id}
                  className={`message ${
                    user.id === message.senderId ? "sender" : "receiver"
                  }`}
                >
                  <div className="d-flex justify-content-start">
                    <img
                      src={
                        user.id === message.senderId
                          ? senderHasImg
                            ? `${ApiConnectionString}/api/profileImageByAppUser/${senderImgId}`
                            : ProfilePlaceHolder
                          : receiverHasImg
                          ? `${ApiConnectionString}/api/profileImageByAppUser/${receiverImgId}`
                          : ProfilePlaceHolder
                      }
                      alt="Profile Image"
                      width={50}
                      height={50}
                      className="img-fluid rounded-circle"
                    />
                    <strong className="message-sender mx-1">
                      {user.id !== message.senderId ? message.username : "Me"}
                    </strong>
                    <p className="text-muted">
                      {new Date(message.timestamp).toLocaleDateString()}{" "}
                      {new Date(message.timestamp).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </p>
                    <Dropdown>
                      <Dropdown.Toggle
                        as="span"
                        id="dropdown-custom-components"
                        className="dropdown-toggle-custom"
                      >
                        <ThreeDotsVertical
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSelectedMessage(message);
                          }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {user.id === message.senderId ? (
                          <Dropdown.Item
                            onClick={() => {
                              setDeleteMessageModal(true);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        ) : (
                          <Dropdown.Item
                            onClick={() => {
                              setreportMessageModal(true);
                            }}
                          >
                            Report
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <p className="message-content">{message.content}</p>
                </div>
              ))}

              <div ref={messagesEndRef} />
            </div >

            {error && <p className="error-message">{error}</p>}

            <div className="message-box text-center">
              {available ? (
                <form onSubmit={handleSubmit}>
                  <textarea
                    placeholder="Type your message..."
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    disabled={submitting}
                    required
                    rows="4" /* You can adjust the number of rows */
                    className="textAreaConvo"
                  ></textarea>
<br></br>
                  <button
                    className="btn btn-primary btn-lg"
                    disabled={submitting || !content}
                  >
                    {submitting ? "Sending..." : "Send"}
                  </button>
                </form>
              ) : (
                <p>Conversation Unavilable</p>
              )}
            </div>
          </div>
        </div>
      ) : (
        <LoadingSpinner />
      )}
      {blockUser && (
        <BlockModal
          cancelModal={cancelModal}
          id={receiverImgId}
          username={username}
          fetchData={fetchData}
        />
      )}
      {UnblockUser && (
        <UnBlockModal
          cancelModal={cancelModal}
          id={receiverImgId}
          username={username}
          fetchData={fetchData}
        />
      )}
      {deleteMessageModal && (
        <DeleteMessageModal
          cancelModal={cancelModal}
          message={selectedMessage}
          fetchData={fetchMessages}
        />
      )}
      {reportMessageModal && (
        <ReportMessageModal
          cancelModal={cancelModal}
          message={selectedMessage}
          fetchData={fetchMessages}
        />
      )}
      {deleteConvoModal && (
        <DeleteConversationModal
          id={id}
          fetchData={fetchData}
          cancelModal={cancelModal}
        />
      )}
    </div>
  );
};

export default Convo;
